import { useState } from "react";
import { CreateAccountPane } from "./CreateAccountPane";
import { SignInPane } from "./SignInPane";

export interface AuthenticateForQuotesDialogBodyProps {
  onDone: () => void;
  onCancel: () => void;
}

export interface SignInPaneProps {
  onDone: () => void;
  onCancel: () => void;
  onCreateAccountInstead: () => void;
}

export interface CreateAccountPaneProps {
  onDone: () => void;
  onCancel: () => void;
  onSignInInstead: () => void;
}

export function AuthenticateForQuotesDialogBody(
  props: AuthenticateForQuotesDialogBodyProps,
) {
  const [showSignIn, setShowSignIn] = useState(false);
  async function onSignInInstead() {
    setShowSignIn(true);
  }

  async function onCreateAccountInstead() {
    setShowSignIn(false);
  }

  if (showSignIn) {
    return (
      <SignInPane {...props} onCreateAccountInstead={onCreateAccountInstead} />
    );
  } else {
    return <CreateAccountPane {...props} onSignInInstead={onSignInInstead} />;
  }
}
